export const scoreSummary = {
  score: 42,
  change: "+8%",
};

export const aiSummary = {
  lastUpdated: "Oct 29, 2025 09:23 UTC",
  executive:
    "System has detected a correlation between outdated firmware on 'PLC-PROD-12' and an increase in 'Command Execution' attempts. Recommend immediate patching of 3 critical assets.",
  confidence: "87% (High)",
  methodology:
    "Multi-model ensemble combining heuristic behavior analysis and threat intelligence correlation.",
};

export const recommendedActions = [
  {
    priority: "Critical Priority",
    priorityTone: "priorityCritical",
    borderColor: "#dc2626",
    title: "Patch Critical Vulnerability CVE-2023-4501",
    description:
      "Outdated firmware on PLC-PROD-12 is vulnerable to remote code execution. Attackers are currently scanning for this entry point in the Production Zone. Immediate update required to prevent operational downtime.",
    cve: "CVE-2023-4501",
  },
  {
    priority: "High Priority",
    priorityTone: "priorityHigh",
    borderColor: "#f59e0b",
    title: "Resolve Unauthorized Modbus Commands",
    description:
      "Unusual write commands detected from Workstation-ENG-04 targeting the Water Pump RTU. Pattern suggests potential lateral movement. Verify user credentials and restrict session access.",
    cve: "Behavioral Alert",
  },
  {
    priority: "Medium Priority",
    priorityTone: "priorityMedium",
    borderColor: "#38bdf8",
    title: "Enable MFA for Administrative Accounts",
    description:
      "4 administrative logins were recorded without Multi-Factor Authentication in the last 24 hours. Compliance score is being negatively impacted. Enforce MFA via Zero-Trust policy.",
    cve: "Policy Gap",
  },
  {
    priority: "Low Priority",
    priorityTone: "priorityLow",
    borderColor: "#0ea5e9",
    title: "Update Expired SSL Certificates",
    description:
      "External-facing asset Gateway-01 is using an SSL certificate that expires in 3 days. Renew certificate to maintain secure communication channels with external partners.",
    cve: "Certificate Expiry",
  },
];

export const riskTrend = [
  { month: "Jan", score: 82 },
  { month: "Feb", score: 81 },
  { month: "Mar", score: 78 },
  { month: "Apr", score: 76 },
  { month: "May", score: 74 },
  { month: "Jun", score: 72 },
  { month: "Jul", score: 70 },
  { month: "Aug", score: 68 },
  { month: "Sep", score: 60 },
  { month: "Oct", score: 52 },
  { month: "Nov", score: 48 },
  { month: "Dec", score: 42 },
];

export const riskFactors = [
  {
    asset: "SCADA-CTRL-01",
    category: "Controller",
    score: 87,
    cve: "CVE-2023-4501",
    lastScanned: "15m ago",
    status: "Protected",
  },
  {
    asset: "PLC-PROD-12",
    category: "PLC",
    score: 72,
    cve: "CVE-2024-1102",
    lastScanned: "1h ago",
    status: "Protected",
  },
  {
    asset: "HMI-FLOOR-3",
    category: "HMI",
    score: 68,
    cve: "Weak Password",
    lastScanned: "2h ago",
    status: "Protected",
  },
  {
    asset: "RTU-PUMP-08",
    category: "RTU",
    score: 55,
    cve: "Open Port 502",
    lastScanned: "4h ago",
    status: "Protected",
  },
  {
    asset: "IoT-SENSOR-247",
    category: "Sensor",
    score: 51,
    cve: "Outdated Cert",
    lastScanned: "6h ago",
    status: "Protected",
  },
];
